function normalizeUidKey(uid) {
  if (uid === null || uid === undefined || uid === '') {
    return ''
  }

  const numericUid = Number(uid)

  if (Number.isFinite(numericUid)) {
    return String(numericUid)
  }

  return String(uid).trim()
}

export function hasTrackedRtcRemoteUser(remoteUsersMap = {}, rtcUid) {
  const uidKey = normalizeUidKey(rtcUid)

  if (!uidKey) {
    return false
  }

  return Boolean(remoteUsersMap?.[uidKey])
}

export function resolveAgoraPresenceRetireOptions(
  remoteUsersMap = {},
  rtcUid,
  overrides = {},
) {
  const trackedRtcRemote = hasTrackedRtcRemoteUser(remoteUsersMap, rtcUid)

  return {
    removeRemote:
      typeof overrides?.removeRemote === 'boolean'
        ? overrides.removeRemote
        : !trackedRtcRemote,
    preserveRtcMetadata:
      typeof overrides?.preserveRtcMetadata === 'boolean'
        ? overrides.preserveRtcMetadata
        : trackedRtcRemote,
  }
}
